"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _polished = require("polished");

var _styledComponents = require("styled-components");

var _motion = require("../../../style/motion");

var _selectors = require("../../../style/selectors");

var ButtonStyle = (0, _styledComponents.css)(["display:inline-flex;align-items:center;justify-content:center;font-weight:500;font-size:", ";line-height:", ";padding:11px 21px;border:2px solid transparent;border-radius:50px;background-image:none;cursor:pointer;transition:0.3s all;flex-shrink:0;outline:none;text-decoration:none;", " box-shadow:", ";&:focus{box-shadow:rgba(66,153,225,0.6) 0 0 0 3px;}", " ", " ", " ", " ", " ", " ", ""], (0, _polished.rem)('16px'), (0, _polished.rem)('19px'), (0, _motion.sharedTransition)('background-color, color, box-shadow'), function (props) {
  return props.shadow ? '0 6px 12px rgba(98, 77, 227, 0.3)' : 'none';
}, function (props) {
  return props.xsmall && (0, _styledComponents.css)(["padding:6px 16px;min-width:112px;"]);
}, function (props) {
  return props.medium && (0, _styledComponents.css)(["padding:10px 30px;"]);
}, function (props) {
  return props.large && (0, _styledComponents.css)(["padding:10px 52px;"]);
}, function (props) {
  return props.wide && (0, _styledComponents.css)(["min-width:232px;"]);
}, function (props) {
  return props.withIcon && (0, _styledComponents.css)(["svg{margin-right:10px;}"]);
}, function (props) {
  return props.withIconAfter && (0, _styledComponents.css)(["svg{margin-left:10px;}"]);
}, function (props) {
  var style;

  if (props.primary) {
    style = (0, _styledComponents.css)(["background-color:var(--brandPrimary);color:var(--colors-blank);fill:var(--colors-blank);&:hover,&:focus{background-color:", ";}"], function (_ref) {
      var theme = _ref.theme;
      return (0, _polished.setSaturation)(0.55, (0, _polished.darken)(0.1, theme.brandPrimary));
    });
  }

  if (props.primaryLight) {
    style = (0, _styledComponents.css)(["background-color:", ";color:var(--brandPrimary);border:1px solid transparent;&:hover{background-color:", ";}", " svg{fill:var(--brandPrimary);}"], function (_ref2) {
      var theme = _ref2.theme;
      return (0, _polished.lighten)(0.35, theme.brandPrimary);
    }, function (_ref3) {
      var theme = _ref3.theme;
      return (0, _polished.lighten)(0.3, theme.brandPrimary);
    }, (0, _selectors.focusVisible)((0, _styledComponents.css)(["box-shadow:0 0 0 3px ", ";"], function (_ref4) {
      var theme = _ref4.theme;
      return (0, _polished.transparentize)(0.5, theme.brandPrimary);
    })));
  }

  if (props.primaryAlt) {
    style = (0, _styledComponents.css)(["color:var(--brandPrimary);background-color:var(--colors-blank);&:hover{color:var(--colors-blank);background-color:var(--purple3);}&:focus{border-color:rgba(54,57,164,0.4);}"]);
  }

  if (props.primaryAltBorder) {
    style = (0, _styledComponents.css)(["color:var(--brandPrimary);background-color:transparent;border-color:", ";&:hover,&[aria-pressed='true']{background-color:", ";}", ""], (0, _polished.rgba)('#624de3', 0.3), function (_ref5) {
      var theme = _ref5.theme;
      return (0, _polished.transparentize)(0.9, theme.brandPrimary);
    }, (0, _selectors.focusVisible)((0, _styledComponents.css)(["background-color:", ";box-shadow:0 0 0 2px ", ";"], function (_ref6) {
      var theme = _ref6.theme;
      return (0, _polished.transparentize)(0.9, theme.brandPrimary);
    }, function (_ref7) {
      var theme = _ref7.theme;
      return (0, _polished.transparentize)(0.5, theme.brandPrimary);
    })));
  }

  if (props.secondary) {
    style = (0, _styledComponents.css)(["color:var(--colors-blank);background-color:var(--brandSecondary);"]);
  }

  if (props.secondaryBorder) {
    style = (0, _styledComponents.css)(["color:var(--brandSecondary);background-color:transparent;border-color:", ";"], (0, _polished.rgba)('#01b0bb', 0.3));
  }

  if (props.neutralLightBorder) {
    style = (0, _styledComponents.css)(["color:var(--colors-blank);background-color:transparent;border-color:", ";&:focus,&:hover{color:var(--brandPrimary);background-color:var(--colors-blank);}"], (0, _polished.rgba)('#fff', 0.3));
  }

  if (props.danger) {
    style = (0, _styledComponents.css)(["color:var(--colors-blank);background-color:var(--colors-redPink);"]);
  }

  if (props.dangerAltBorder) {
    style = (0, _styledComponents.css)(["color:var(--colors-redPink);background-color:transparent;border-color:var(--colors-redPink);&:hover{color:var(--colors-blank);background-color:var(--colors-redPink);}&:disabled{border-color:rgba(119,140,163,0.3);color:var(--colors-lynch);background-color:transparent;}"]);
  }

  if (props.warning) {
    style = (0, _styledComponents.css)(["color:var(--colors-blank);background-color:var(--orange1);"]);
  }

  return style;
});
var _default = ButtonStyle;
exports["default"] = _default;